import { useSoftDeployAccess } from './featureHelper';

const useWebhookRoutinesAccess = (): boolean => useSoftDeployAccess('AGENT_WEBHOOK_ROUTINES');

export default useWebhookRoutinesAccess;
